export default __webpack_public_path__ + "static/media/telegram.be6948c6.png";